import { useMutation, useQueryClient } from "@tanstack/react-query"
import api from "../../http"
import { getApiErrorMessage, toApiError } from "../utils"

export const useDeleteuser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id: string) => {
            try {
                return (await api.delete(`/management/user/delete/${id}`)).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar usuário');
            }
        },
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            queryClient.invalidateQueries({ queryKey: ['userId', id] });
        },
        onError: error => console.error('Erro ao deletar usuário:', getApiErrorMessage(error, 'Erro ao deletar usuário')),
    })
}
